import React, { useMemo } from 'react';
import { MdArchive } from 'react-icons/md';
import { COLORS } from '@ydistri/theme';
import { InfoIconTooltip } from '../../icons/InfoIconTooltip';

export interface ArchivedEntityListIconProps {
  content?: React.ReactNode;
  size?: number;
  color?: string;
}

/**
 * Icon indicating that the entity list is archived, with a tooltip.
 */
const ArchivedEntityListIcon: React.FC<ArchivedEntityListIconProps> = ({
  content = 'This list is archived.',
  size = 16,
  color = COLORS.GREY,
}) => {
  const icon = useMemo(
    () => <MdArchive size={size} color={color} aria-hidden="true" />,
    [size, color],
  );

  return <InfoIconTooltip icon={icon} content={content} />;
};

export default ArchivedEntityListIcon;
